import { api } from '../api';
import type { operations, Task } from '../types';
/* istanbul ignore file */

export const taskApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTask: builder.query<Task, operations['retrieveTask']['parameters']['path']['id']>({
      query: (taskId) => ({
        url: `api/tasks/${taskId}/`,
      }),
    }),
  }),
});
